export const GET_ROLE_PENDING = "GET_ROLE_PENDING";
export const GET_MORE_ROLE_PENDING = "GET_MORE_ROLE_PENDING";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_MORE_ROLE_SUCCESS = "GET_MORE_ROLE_SUCCESS";
export const RESET_ROLE = "RESET_ROLE";
